import {ImageInterface} from 'app/types/ImageInterface';
import VideoClub from 'app/components/tv/models/VideoClub';
import VideoTeamInterface from 'app/components/tv/models/VideoTeamInterface';
import {MatchTeamModel} from 'app/models/match/MatchTeamModel';
import {ImageProps} from '@fupa/fupa-uikit/dist/components/image/Image';

export default class VideoTeam {
  readonly id: number;
  readonly teamId: number;
  readonly slug: string;
  readonly name: {
    full: string;
    middle: string;
    short: string;
  };
  readonly image: ImageInterface;
  readonly origin: string;
  readonly ageGroup: {
    slug: string;
    name: string;
  };
  readonly linkUrl: string;
  readonly level: number;
  readonly clubSlug: string;
  readonly club: VideoClub;
  readonly matchTeam: MatchTeamModel;

  constructor(data: VideoTeamInterface) {
    Object.assign(this, data);
    this.matchTeam = new MatchTeamModel(data);
    this.club = new VideoClub(data.club);
  }

  getTeamName(): string {
    return this.matchTeam.formatNameWithLevel();
  }

  getImageProps(): ImageProps | null {
    return this.matchTeam.getImageData();
  }
}
